/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import Vue from "vue"
import axios from "axios"
import VueAxios from "vue-axios"
import VuejsDialog from "vuejs-dialog"
import VModal from "vue-js-modal"
import VueQuillEditor from "vue-quill-editor"
import VueRouter from "vue-router"
import VueSimplemde from "vue-simplemde"
import VueYouTubeEmbed from "vue-youtube-embed"
import VueMarkdown from "vue-markdown"
import Loading from "vue-loading-overlay"
import VueSwal from "vue-swal"
import VueNoty from "vuejs-noty"
import VueMq from "vue-mq"
import VeeValidate from "vee-validate"
/* to load and use React component in vue app */
import { VuePlugin } from "vuera"
import { capitalize } from "@/utils/filter"
import router from "@/router/index"
import store from "./store/index"
import "../public/kotapi-boilet.css"
import App from "./App.vue"

// require styles for quill
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import "vue-loading-overlay/dist/vue-loading.css"
import "vuejs-noty/dist/vuejs-noty.css"
import "@/assets/css/github.markdown.css"
import "@/assets/css/tailwind.postcss"
import "react-datepicker/dist/react-datepicker.css"

Vue.config.productionTip = false

Vue.use(VuePlugin)
Vue.use(Loading)
Vue.use(VueMarkdown)
Vue.use(VueYouTubeEmbed)
Vue.use(VueSimplemde)
Vue.use(VueQuillEditor /* { default global options } */)
Vue.use(VModal, { componentName: "VModal" })
Vue.use(VueRouter)
Vue.use(VuejsDialog)
Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.use(VueSwal)
Vue.filter("capitalize", capitalize)
Vue.use(VueNoty, {
  layout: "bottomLeft",
  timeout: 4000,
  animation: {
    open: "slideUp",
    close: "fadeOut",
    progressBar: false,
  },
})
Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: Infinity,
  },
})

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid",
  },
  // Workaround for conflict between veevalidate and vue-form-generator
  errorBagName: "veeValidateErrors",
  fieldsBagName: "veeValidateFields",
})

// Interceptor for 401 Requests
Vue.axios.interceptors.response.use(
  response =>
    // intercept the global error
    response,
  error => {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      // if the error is 401 and hasent already been retried
      localStorage.token = undefined
      localStorage.userName = undefined

      window.location = "/"
      window.location.href = "/"
      return
    }
    if (error.response.status === 404 && !originalRequest._retry) {
      // originalRequest._retry = true;
      // window.location.href = "/";
      return
    }
    // Do something with response error
    return Promise.reject(error)
  }
)

Vue.axios.interceptors.request.use(config => {
  config.headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(localStorage.token && { "x-access-token": localStorage.token }),
  }
  return config
})
/* We're adding a new REACTIVE property pageTitle to window, whenever we assign
new value to it browser title will be updated automatically  */
Object.defineProperty(window, "pageTitle", {
  set(newValue) {
    document.title = `${newValue} | Admin - Edyst`
  },
})

Vue.router = router

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount("#app")
